<div class="container">
    <app-section-header title="{{ title }}" [actionsTemplate]="actionsTemplate" [iconName]="'goBack'">
        <ng-template #actionsTemplate>
            <div class="actions">
                <button class="secondary-btn" (click)="cancel()">Cancel</button>
                <button class="primary-btn" (click)="saveBuilding()">{{ buttonLabel }}</button>
            </div>
        </ng-template>
    </app-section-header>

    <div class="cardsContainer">
        <app-buildings-single-overview
            [building]="building"
            [isReadOnly]="false"
            #overview
        ></app-buildings-single-overview>
    </div>
</div>
